import { generateFormData } from "../../shared/utils/formHelper";
import { EnquireModalBody } from "../../interfaces/connected-components/enquireModal";
import { services } from "../../api";
import { toastService } from "../../shared/utils/toast";
import environment from "../../environment/environment";

export const register = async (body: EnquireModalBody): Promise<boolean> => {
  try {
    const form = generateFormData(body);
    const res = await services.register.submit(form);
    if (res.result !== "success") return false;
    toastService.showSuccessToast(
      "Thank you for registering. We will get back to you soon.",
    );
    return true;
  } catch (error) {
    if (environment.debug) console.error(error);
    return false;
  }
};
